import {DesktopPlayerControls} from '@app/web-player/player-controls/desktop-player-controls';
import {MobilePlayerControls} from '@app/web-player/player-controls/mobile-player-controls';
import {usePlayerStore} from '@common/player/hooks/use-player-store';
import {useIsTabletMediaQuery} from '@ui/utils/hooks/is-tablet-media-query';
import clsx from 'clsx';
import {useLocation} from 'react-router';

const NON_WEB_PLAYER_PREFIXES = [
  '/admin',
  '/billing',
  '/checkout',
  '/backstage',
  '/account-settings',
  '/api-docs',
];

function isNonWebPlayerRoute(pathname: string): boolean {
  return NON_WEB_PLAYER_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/** Player controls on admin/billing/backstage routes (web player has its own bar). */
export function GlobalPlayerBar() {
  const {pathname} = useLocation();
  const isMobile = useIsTabletMediaQuery();
  const mediaIsCued = usePlayerStore(s => s.cuedMedia != null);

  if (!isNonWebPlayerRoute(pathname) || !mediaIsCued) {
    return null;
  }

  if (isMobile) {
    return (
      <div className="fixed inset-x-0 bottom-0 z-40">
        <MobilePlayerControls />
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'player-section fixed inset-x-0 bottom-0 z-40 border-t border-divider bg-elevated',
      )}
    >
      <DesktopPlayerControls />
    </div>
  );
}
